import formattedDate from './formattedDate';
import formattedDateTime from './formattedDateTime';
import formattedTime from './formattedTime';
import nl2br from './nl2br';
import numberFixedLength from './numberFixedLength';
import safeHtml from './safeHtml';
import safeUrl from './safeUrl';

export const load = (app) => {
	app.filter('date', formattedDate);
	app.filter('dateTime', formattedDateTime);
	app.filter('nl2br', nl2br);
	app.filter('numberFixedLength', numberFixedLength);
	app.filter('safeHtml', safeHtml);
	app.filter('safeUrl', safeUrl);
	app.filter('time', formattedTime);
};


// WEBPACK FOOTER //
// ./src/js/filters/loader.js